import { render, staticRenderFns } from "./openclose.vue?vue&type=template&id=b9462f2c&"
import script from "./openclose.vue?vue&type=script&lang=ts&"
export * from "./openclose.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports